if (!customElements.get('product-family-picker')) {
  class ProductFamilyPicker extends HTMLElement {
    static responseCache = new Map();

    constructor() {
      super();

      this.handleClick = this.handleClick.bind(this);
      this.handlePointerEnter = this.handlePointerEnter.bind(this);
      this.handleFocusIn = this.handleFocusIn.bind(this);
    }

    connectedCallback() {
      this.productInfo = this.closest('product-info');
      if (!this.productInfo) return;

      this.addEventListener('click', this.handleClick);
      this.addEventListener('pointerenter', this.handlePointerEnter, true);
      this.addEventListener('focusin', this.handleFocusIn);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('pointerenter', this.handlePointerEnter, true);
      this.removeEventListener('focusin', this.handleFocusIn);
    }

    handlePointerEnter(event) {
      const link = event.target.closest('[data-family-product-link]');
      if (!link || link.classList.contains('is-current')) return;

      this.prefetch(link.href);
    }

    handleFocusIn(event) {
      const link = event.target.closest('[data-family-product-link]');
      if (!link || link.classList.contains('is-current')) return;

      this.prefetch(link.href);
    }

    handleClick(event) {
      const link = event.target.closest('[data-family-product-link]');
      if (!link || !this.contains(link) || link.classList.contains('is-current')) return;

      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      event.preventDefault();
      this.navigate(link.href, link);
    }

    prefetch(url) {
      return this.fetchPage(url).catch(() => undefined);
    }

    fetchPage(url) {
      const cachedResponse = ProductFamilyPicker.responseCache.get(url);
      if (cachedResponse) {
        return Promise.resolve(cachedResponse);
      }

      const request = fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error(`Failed to load ${url}`);
          return response.text();
        })
        .then((htmlText) => {
          ProductFamilyPicker.responseCache.set(url, htmlText);
          return htmlText;
        })
        .catch((error) => {
          ProductFamilyPicker.responseCache.delete(url);
          throw error;
        });

      ProductFamilyPicker.responseCache.set(url, request);
      return request;
    }

    navigate(url, link) {
      if (!this.productInfo) {
        window.location.assign(url);
        return;
      }

      this.productInfo.setAttribute('aria-busy', 'true');

      this.fetchPage(url)
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const newProductInfo = html.querySelector("product-info[id^='MainProduct']") || html.querySelector('product-info');

          if (!newProductInfo) {
            throw new Error('Updated product information was not found in the response.');
          }

          newProductInfo.querySelectorAll('.scroll-trigger').forEach((element) => {
            element.classList.add('scroll-trigger--cancel');
          });

          HTMLUpdateUtility.viewTransition(this.productInfo, newProductInfo, [], [
            (newNode) => {
              window?.Shopify?.PaymentButton?.init();
              window?.ProductModel?.loadShopifyXR();
              const currentSwatch = newNode.querySelector('.product-family-picker__swatch-link.is-current');
              currentSwatch?.focus();
            },
          ]);

          const nextTitle = html.querySelector('head title');
          if (nextTitle) {
            document.title = nextTitle.textContent;
          }

          window.history.replaceState({}, '', url);
        })
        .catch(() => {
          window.location.assign(url);
        })
        .finally(() => {
          this.productInfo?.removeAttribute('aria-busy');
        });
    }
  }

  customElements.define('product-family-picker', ProductFamilyPicker);
}